import { render } from "./carrusel3_ingles.vue?vue&type=template&id=009b2f18&scoped=true"
import script from "./carrusel3_ingles.vue?vue&type=script&lang=js"
export * from "./carrusel3_ingles.vue?vue&type=script&lang=js"

import "./carrusel3_ingles.vue?vue&type=style&index=0&id=009b2f18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009b2f18"]])

export default __exports__